<template>
    <ul v-if="accessToken">
        <li>
            <router-link to="/mypage/myinfo">
                <span>마이페이지</span>
            </router-link>
        </li>
        <li>
            <router-link to="" @click.native="navigate">
                <span>{{ $t("로그아웃") }}</span>
            </router-link>
        </li>
    </ul>
    <ul v-else>
        <li>
            <router-link to="/join/type">
                <span>회원가입</span>
            </router-link>
        </li>
        <li>
            <router-link to="" @click.native="navigate">
                <span>{{ $t("로그인") }}</span>
            </router-link>
        </li>
    </ul>
</template>
<script>
export default {
    methods: {
        navigate(){
            if(this.accessToken){
                this.$store.dispatch("logout");
            }
            else{
                this.$router.push(`/login`);
            }
        }
    },
    computed: {
        accessToken(){
            return this.$store.state.accessToken;
        }
    }
}
</script>